@if (currentTenant$ | async) {
    <app-main-inbox />
} @else {
    <span class="color-gray12">
        Please select a tenant to display documents.
    </span>
}
